import { apiAuth, apiResponseType } from ".";

export const getClientsData = (page: number = 1, seller_id?: string): apiResponseType => {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page.toString());
  if (seller_id) queryParams.append("seller_id", seller_id);
  return apiAuth.get(`clients?${queryParams.toString()}`);
};

// Nova função com suporte a todos os filtros e ordenação
export const getClientsDataWithFilters = (params: {
  page?: number;
  per_page?: number;
  name?: string;
  phone?: string;
  email?: string;
  document?: string;
  seller_id?: string;
  client_origin_id?: number;
  client_category_id?: number;
  has_purchase_voucher?: boolean;
  has_discount?: boolean;
  is_new?: boolean;
  order_by?: 'name' | 'total_balance' | 'created_at';
  order_direction?: 'asc' | 'desc';
  is_active?: boolean;
}): apiResponseType => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page.toString());
  if (params.per_page) queryParams.append("per_page", params.per_page.toString());
  if (params.name) queryParams.append("name", params.name);
  if (params.phone) queryParams.append("phone", params.phone);
  if (params.email) queryParams.append("email", params.email);
  if (params.document) queryParams.append("document", params.document);
  if (params.seller_id) queryParams.append("seller_id", params.seller_id);
  if (params.client_origin_id) queryParams.append("client_origin_id", params.client_origin_id.toString());
  if (params.client_category_id) queryParams.append("client_category_id", params.client_category_id.toString());
  if (params.has_purchase_voucher !== undefined) queryParams.append("has_purchase_voucher", params.has_purchase_voucher ? "1" : "0");
  if (params.has_discount !== undefined) queryParams.append("has_discount", params.has_discount ? "1" : "0");
  if (params.is_new !== undefined) queryParams.append("is_new", params.is_new ? "1" : "0");
  if (params.order_by) queryParams.append("order_by", params.order_by);
  if (params.order_direction) queryParams.append("order_direction", params.order_direction);
  if (params.is_active !== undefined) queryParams.append("is_active", params.is_active ? "1" : "0");

  return apiAuth.get(`clients?${queryParams.toString()}`);
};

export const registerClientsData = (data) =>
  apiAuth.postForm("/clients/store", data) as apiResponseType;
export const deleteClientsData = (tenid: string) =>
  apiAuth.delete(`clients/${tenid}/destroy`) as apiResponseType;
export const updateClientsData = (tenid: string, data) =>
  apiAuth.postForm(`clients/${tenid}/update`, data) as apiResponseType;

export const getShowClients = (tenid: string) =>
  apiAuth.get(`clients/${tenid}/show`) as apiResponseType;

export const searchClientsData = (params: { name: string, seller_id?: string }): apiResponseType => {
  const queryParams = new URLSearchParams();
  if (params.name) queryParams.append("name", params.name);
  if (params.seller_id) queryParams.append("seller_id", params.seller_id);
  return apiAuth.get(`clients?${queryParams.toString()}`);
};

export const setStatusClients = (tenid: string) =>
  apiAuth.put(`clients/${tenid}/toggle-status`) as apiResponseType;

export const checkPhoneExists = (phone: string, excludeUuid?: string): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("phone", phone);
  if (excludeUuid) queryParams.append("exclude_uuid", excludeUuid);
  return apiAuth.get(`clients/check-phone?${queryParams.toString()}`);
};

export const getSelectClients = (params?: { name?: string; phone?: string }) => {
  const queryParams = new URLSearchParams();
  if (params?.name) queryParams.append("name", params.name);
  if (params?.phone) queryParams.append("phone", params.phone);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  return apiAuth.get(`clients/select${queryString}`) as apiResponseType;
};

export const getSelectAllClientsAndLeads = (params?: {
  name?: string;
  seller_id?: string;
  phone?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (params?.name) queryParams.append("name", params.name);
  if (params?.phone) queryParams.append("phone", params.phone);
  if (params?.seller_id) queryParams.append("seller_id", params.seller_id);

  const queryString = queryParams.toString()
    ? `?${queryParams.toString()}`
    : "";
  return apiAuth.get(`clients/select-all${queryString}`) as apiResponseType;
};

export const getClientBalance = (
  uuid: string,
  balance_origin_type_id?: number
) => {
  const params = balance_origin_type_id
    ? { balance_origin_type_id }
    : undefined;
  return apiAuth.get(`clients/${uuid}/balance`, { params }) as apiResponseType;
};

export const storeClientBalance = (
  uuid: string,
  balance: number,
  description: string,
  files: File[],
  hasPurchaseVoucher: boolean
) => {
  const formData = new FormData();
  formData.append("balance", balance.toString());
  formData.append("description", description);
  files.forEach((file) => {
    formData.append("files[]", file);
  });
  formData.append("has_purchase_voucher", hasPurchaseVoucher ? "1" : "0");

  return apiAuth.post(`clients/${uuid}/balances/store`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }) as apiResponseType;
};

export const getBalancesOnClient = (id: string, page: number = 1) =>
  apiAuth.get(`clients/balances`, {
    params: {
      client_id: id || undefined,
      page,
    },
  }) as apiResponseType;

export const exportClientBalanceHistory = (clientId: string): Promise<Blob> =>
  apiAuth
    .get(`clients/balances/export`, {
      params: { client_id: clientId },
      responseType: "blob",
    })
    .then((response: any) => response.data);

export const getSalesByClient = (uuid: string, params?: { seller_id?: string }) => {
  const queryParams = new URLSearchParams();
  if (params?.seller_id) queryParams.append("seller_id", params.seller_id);
  return apiAuth.get(`clients/${uuid}/sales?${queryParams.toString()}`) as apiResponseType;
};
